// extracted by mini-css-extract-plugin
export default {"modal":"FailedPopup_modal__vi2TB","title":"FailedPopup_title__RIUuP","button":"FailedPopup_button__+5A+d"};